export default "__VITE_ASSET__BHdS_HVt__"